import React, { useEffect, useState, forwardRef } from 'react';

import '../UI/PrintReport.css';
import { useApi } from '../ContextApi/ContextApi';
import Template1 from '../Templates/Template1';
import Template2 from '../Templates/Template2';
import Template3 from '../Templates/Template3';
import Template4 from '../Templates/Template4';
import Template5 from '../Templates/Template5/Template5';
import Template6 from '../Templates/Template6/Template6 ';
import Template7 from '../Templates/Template7/Template7';



const PrintReports = forwardRef(({reportData,QrCodeURL}, ref) => {
  return (
    <>
      {reportData?.[0]?.selectedTemplate === '1' ? (
      <div ref={ref}>
       <Template1 reportData={reportData}  QRurl={QrCodeURL} />
     </div>
     ) : reportData?.[0]?.selectedTemplate === '2' ? (
    <div  ref={ref}>
      <Template2 reportData={reportData}  QRurl={QrCodeURL} />
    </div>
    ) :reportData?.[0]?.selectedTemplate === '3' ?  (
      <div ref={ref}>
      <Template3  reportData={reportData} QRurl={QrCodeURL}/>
     </div>
   ):reportData?.[0]?.selectedTemplate === '4' ?  (
      <div ref={ref}>
      <Template4  reportData={reportData} QRurl={QrCodeURL}/>
     </div>
   ):reportData?.[0]?.selectedTemplate === '6' ?  (
      <div ref={ref}>
      <Template6  reportData={reportData} QRurl={QrCodeURL}/>
     </div>
   ):reportData?.[0]?.selectedTemplate === '7' ?  (
      <div ref={ref}>
      <Template7  reportData={reportData} QRurl={QrCodeURL}/>
     </div>
   ):
   <div ref={ref}>
     <Template5  reportData={reportData} QRurl={QrCodeURL}/>
    </div>
    }
    </>
  );
});

export default PrintReports;
